import { Layout } from '@/utils/routerHelper'

const { t } = useI18n()
/**
 * redirect: noredirect        当设置 noredirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'          设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
 hidden: true              当设置 true 的时候该路由不会再侧边栏出现 如404，login等页面(默认 false)

 alwaysShow: true          当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式，
 只有一个时，会将那个子路由当做根路由显示在侧边栏，
 若你想不管路由下面的 children 声明的个数都显示你的根路由，
 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，
 一直显示根路由(默认 false)

 title: 'title'            设置该路由在侧边栏和面包屑中展示的名字

 icon: 'svg-name'          设置该路由的图标

 noCache: true             如果设置为true，则不会被 <keep-alive> 缓存(默认 false)

 breadcrumb: false         如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)

 affix: true               如果设置为true，则会一直固定在tag项中(默认 false)

 noTagsView: true          如果设置为true，则不会出现在tag中(默认 false)

 activeMenu: '/dashboard'  显示高亮的路由路径

 followAuth: '/dashboard'  跟随哪个路由进行权限过滤

 canTo: true               设置为true即使hidden为true，也依然可以进行路由跳转(默认 false)
 }
 **/
const remainingRouter: AppRouteRecordRaw[] = [
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect1',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: 'Home',
    meta: {},
    children: [
      {
        path: 'index',
        component: () => import('@/views/Home/Index.vue'),
        name: 'Index',
        meta: {
          title: t('router.home'),
          icon: 'ep:home-filled',
          noCache: false,
          affix: true
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    name: 'UserInfo',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/Profile/Index.vue'),
        name: 'Profile',
        meta: {
          canTo: true,
          hidden: true,
          noTagsView: false,
          icon: 'ep:user',
          title: t('common.profile')
        }
      },
      {
        path: 'notify-message',
        component: () => import('@/views/System/notify/my/index.vue'),
        name: 'MyNotifyMessage',
        meta: {
          canTo: true,
          hidden: true,
          noTagsView: false,
          icon: 'ep:message',
          title: '我的站内信'
        }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/forgot-password',
    component: () => import('@/views/Login/ForgotPassword.vue'),
    name: 'ForgotPassword',
    meta: {
      hidden: true,
      title: '找回密码',
      noTagsView: true
    }
  },
  {
    path: '/change-password',
    component: () => import('@/views/Login/ChangePassword.vue'),
    name: 'ChangePassword',
    meta: {
      hidden: true,
      title: '修改密码',
      noTagsView: true
    }
  },
  {
    path: '/sso',
    component: () => import('@/views/Login/Login.vue'),
    name: 'SSOLogin',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/social-login',
    component: () => import('@/views/Login/SocialLogin.vue'),
    name: 'SocialLogin',
    meta: {
      hidden: true,
      title: t('router.socialLogin'),
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'NoAccess',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFound',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/500',
    component: () => import('@/views/Error/500.vue'),
    name: 'Error',
    meta: {
      hidden: true,
      title: '500',
      noTagsView: true
    }
  },
  {
    path: '/single/:pathMatch(.*)*',
    component: () => import('@/views/Single/index.vue'),
    name: 'Single',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    // 公开分享页无后台布局；路径需同步 SHARE_PAGE_PATH，名称需保留在路由重置白名单。
    path: '/share/material',
    component: () => import('@/views/Share/Material.vue'),
    name: 'MaterialShare',
    meta: {
      hidden: true,
      title: '资料分享',
      noTagsView: true
    }
  },
  {
    // 后端菜单未包含详情页，静态路由使用 Layout 承载。
    path: '/channel/opportunity',
    component: Layout,
    name: 'ChannelOpportunityShell',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'detail',
        component: () => import('@/views/channel/opportunity/detail/index.vue'),
        name: 'ChannelOpportunityDetail',
        meta: {
          hidden: true,
          title: '商机详情',
          activeMenu: '/channel/opportunity/index'
        }
      }
    ]
  },
  {
    // 审批中心的二级页不进菜单：设计与详情由列表/待办进入
    path: '/approval',
    component: Layout,
    name: 'ApprovalShell',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'template-create',
        component: () => import('@/views/approval/template/create.vue'),
        name: 'ApprovalTemplateCreate',
        meta: {
          hidden: true,
          title: '新建审批流',
          activeMenu: '/approval/template'
        }
      },
      {
        path: 'launch/:id',
        component: () => import('@/views/approval/launch/form.vue'),
        name: 'ApprovalLaunchForm',
        meta: {
          hidden: true,
          title: '发起流程',
          activeMenu: '/approval/launch'
        }
      },
      {
        path: 'template-design/:id',
        component: () => import('@/views/approval/template/design.vue'),
        name: 'ApprovalTemplateDesign',
        meta: {
          hidden: true,
          title: '设计流程',
          activeMenu: '/approval/template'
        }
      },
      {
        path: 'form-design/:id',
        component: () => import('@/views/approval/form/design.vue'),
        name: 'ApprovalFormDesign',
        meta: {
          hidden: true,
          title: '设计表单',
          activeMenu: '/approval/form'
        }
      },
      {
        path: 'todo/:id',
        component: () => import('@/views/approval/detail/index.vue'),
        name: 'ApprovalTodoDetail',
        meta: {
          hidden: true,
          title: '待办详情',
          activeMenu: '/approval/todo',
          scene: 'todo'
        }
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/approval/detail/index.vue'),
        name: 'ApprovalDetail',
        meta: {
          hidden: true,
          title: '流程详情',
          scene: 'instance'
        }
      },
      {
        path: 'instance/:id',
        component: () => import('@/views/approval/detail/index.vue'),
        name: 'ApprovalInstanceDetail',
        meta: {
          hidden: true,
          title: '实例详情',
          activeMenu: '/approval/instance',
          viewOnly: true
        }
      }
    ]
  }
]

export default remainingRouter
